import styled from 'styled-components';
import GDBREAKPOINTS from '@gameday/components/themes/breakpoints';
const { SM_WIDE_MIN } = GDBREAKPOINTS;

const BaseBadge = styled.div`
    font-family: var(--gameday-primary-font);
    color: var(--gameday-tag-label-text);
    font-size: 12px;
    line-height: 12px;
    font-weight: 700;
    text-transform: uppercase;
    padding: 4px 6px;
    border-radius: 8px;
    display: inline-flex;
    letter-spacing: 0.96px;

    @media (min-width: ${SM_WIDE_MIN}) {
        line-height: 14px;
        font-size: 14px;
        letter-spacing: 1.12px;
    }
`;

export const DefaultBadge = styled(BaseBadge)`
    background-color: var(--gameday-tag-label-background);
`;

export const LiveBadge = styled(BaseBadge)`
    background-color: var(--gameday-alert-red);
`;

export const WatchFreeBadge = styled(BaseBadge)`
    background-color: var(--gameday-alert-yellow);
    color: var(--gameday-game-context-primary-text-color);
`;

export const PerfectGameBadge = styled(BaseBadge)`
    background-color: var(--gameday-alert-blue);
`;
